import { render, staticRenderFns } from "./AstaSelvaggiaHeaderActions.vue?vue&type=template&id=7bac54d4&scoped=true&"
import script from "./AstaSelvaggiaHeaderActions.vue?vue&type=script&lang=js&"
export * from "./AstaSelvaggiaHeaderActions.vue?vue&type=script&lang=js&"
import style0 from "./AstaSelvaggiaHeaderActions.vue?vue&type=style&index=0&id=7bac54d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bac54d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bac54d4')) {
      api.createRecord('7bac54d4', component.options)
    } else {
      api.reload('7bac54d4', component.options)
    }
    module.hot.accept("./AstaSelvaggiaHeaderActions.vue?vue&type=template&id=7bac54d4&scoped=true&", function () {
      api.rerender('7bac54d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AstaSelvaggiaHeaderActions.vue"
export default component.exports